import React from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { equipment } from "@/data/equipment";

export function HomeEquipment({ t }) {
  return (
    <section className="max-w-[1120px] mx-auto px-4 sm:px-6 mt-14">
      <div className="flex items-end justify-between gap-3">
        <div>
          <h2 className="text-2xl sm:text-3xl font-semibold text-[hsl(var(--brand-navy))]">{t("home.equipment_title")}</h2>
          <p className="text-sm sm:text-base text-[hsl(var(--muted-foreground))] mt-1">{t("home.equipment_sub")}</p>
        </div>
        <Link to="/attrezzature" className="text-sm font-medium text-[hsl(var(--brand-aqua))] hover:underline shrink-0">{t("common.view_all")}</Link>
      </div>
      <div className="mt-5 grid grid-cols-2 lg:grid-cols-4 gap-3">
        {equipment.slice(0, 4).map((e) => (
          <Card key={e.key} className="overflow-hidden card-hover">
            <div className="aspect-[4/3] bg-[hsl(var(--muted))] overflow-hidden">
              <img src={e.image} alt={e.name} loading="lazy" decoding="async" width={400} height={300} className="h-full w-full object-cover" />
            </div>
            <div className="p-3">
              <div className="text-xs font-mono-tech text-[hsl(var(--muted-foreground))]">{e.model}</div>
              <div className="text-sm font-semibold text-[hsl(var(--brand-navy))]">{e.name}</div>
            </div>
          </Card>
        ))}
      </div>
    </section>
  );
}

export default HomeEquipment;
